import { Component, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RptVendors } from '../../models/customer/rpt-vendors';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { CustomerService } from '../../services/customer/customer.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { EnumDropDown } from '../../models/shared/enum-dropdown'
import { ReportService } from '../../services/report/report.service';



@Component({
  selector: 'rpt-vendors-list',
  templateUrl: './rpt-vendors.component.html',
  styleUrls: ['./rpt-vendors.component.scss']
})

export class RptVendorsComponent {
  public searchStatusId: any;
  public searchStatusIdd: any;
  isGenrate: boolean;
  public fromDatee: Date;
  public dateToo: Date;
  public filterStatus: string = "All";
  public filterStore: string = "All";
  public filterDate: string = "N/A";
  public fromDate: string;
  public dateTo: string;
  public customerStatuses: EnumDropDown[];
  public vendorList: RptVendors[]=[];
  @ViewChild('btnGenerate') btnGenerate: ElementRef;
  @ViewChild('btnPrint') btnPrint: ElementRef;

  constructor(
    private readonly reportService: ReportService,
    private readonly customerService: CustomerService,
    public toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService,
    private readonly router: Router, private utilityService: UtilitiesService) {

    this.toastr.setRootViewContainerRef(vcr);
    this.searchStatusId = null;
    this.isGenrate = true;
    this.GetCustomerStatus();
  }

  GetCustomerStatus() {
    this.customerService.GetCustomerStatus().subscribe(
      data => {
        this.customerStatuses = data;

      }
    )
  }

  print() {
    if (this.vendorList.length > 0) {
      this.utilityService.print();
    }
    else {
      this.toastr.info("No date to print");
    }
  }

  generateReport() {
    this.isGenrate = false;
    this.searchStatusIdd = this.searchStatusId;

    if (this.searchStatusIdd == null) {
      this.searchStatusIdd = 0
    }

    if (this.searchStatusIdd != 0 && this.searchStatusIdd != null)
      this.filterStatus = this.customerStatuses.find(x => x.value == (this.searchStatusIdd)).display;
    else
      this.filterStatus = "All";

    var v = new Date(this.dateToo);
    var day = v.getDate();
    var monthIndex = v.getMonth();
    var year = v.getFullYear();
    this.dateTo = year + "-" + (monthIndex + 1) + "-" + day;

    var v = new Date(this.fromDatee);
    var day = v.getDate();
    var monthIndex = v.getMonth();
    var year = v.getFullYear();
    this.fromDate = year + "-" + (monthIndex + 1) + "-" + day;

    this.reportService.getRptVendors(this.searchStatusIdd, this.fromDate, this.dateTo).subscribe(
      d => {
        if (d.success) {
          this.vendorList = d.data;
          this.isGenrate = true;
        }
        else {
          this.vendorList = [];
          this.toastr.error(d.message);
          this.isGenrate = true;
           
        }
      }
    )
  }

  selectFromDate(e) {
    if (e != null) {
      this.fromDatee = e;
    }
  }
  selectDateToo(e) {
    this.dateToo = e;
  }
}



// WEBPACK FOOTER //
// ./src/app/Reports/rpt-vendors/rpt-vendors.component.ts